import { Add as AddIcon } from "@mui/icons-material";
import { Button, ButtonProps } from "@mui/material";
import React from "react";

interface AddButtonProps extends Omit<ButtonProps, 'startIcon' | 'variant' | 'size'> {
  children: React.ReactNode;
  variant?: 'contained' | 'outlined';
  size?: 'small' | 'medium' | 'large';
  showIcon?: boolean;
}

const AddButton: React.FC<AddButtonProps> = ({
  children,
  variant = 'contained',
  size = 'medium',
  showIcon = true,
  sx,
  ...props
}) => {
  return (
    <Button
      variant={variant}
      startIcon={showIcon ? <AddIcon /> : undefined}
      size={size}
      sx={{
        textTransform: "none",
        fontWeight: 500,
        height: size === 'small' ? '32px' : size === 'large' ? '40px' : '36px',
        minWidth: size === 'small' ? '56px' : size === 'large' ? '72px' : '64px',
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default AddButton;
